import { render } from "./NewClientCategoryMapping.vue?vue&type=template&id=deed7436"
import script from "./NewClientCategoryMapping.vue?vue&type=script&lang=js"
export * from "./NewClientCategoryMapping.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__